<script>
  import {IMAGES_V2} from '@/const';
  import Notice, {filterProps} from './Notice.svelte';

  export let message = '';
  export let type = 'success';
</script>

<style>
  .toast {
    margin: 8px 0;
    border-radius: 8px;
    padding: 10px 20px;
    text-align: center;
    font-size: 14px;
    color: #383838;
    pointer-events: auto;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  }
  .success {
    background: #e6f8f3;
    color: #00bd84;
  }
  .danger {
    background: #feedee;
    color: #f24e53;
  }
</style>

<Notice {...filterProps($$props)}>
  <div class="toast" class:success={type === 'success'} class:danger={type === 'danger'} role="alert">
    <div class="text df aic">
      <img class="mr8" width="20" height="20" src={type === 'success' ? IMAGES_V2.SUCCESS_ICON : IMAGES_V2.DANGER_ICON} alt="icon" />
      {@html message}
    </div>
  </div>
</Notice>
